/* eslint-disable react/jsx-no-literals */
/* eslint-disable arrow-body-style */
/* eslint-disable react/react-in-jsx-scope */
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useEffect, useState, useContext, useCallback } from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useModal, Loader } from '@jutro/components';
import { ENTQuestionSetComponent as QuestionSetComponent } from 'ent-capability-quoteandbind-questionsets-ui/index.js';
import { PolicyChangeService } from 'gw-capability-gateway';
import metadata from './TFPARenewalRequalSummary.metadata.json5';
import styles from './TFPARenewalRequalSummary.module.scss';
import messages from './TFPARenewalRequalSummary.messages';
import _ from 'lodash';


function TFPARenewalRequalSummary (props) {

    const { policyNumber, policyType } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const { authHeader } = useAuthentication();
    const { showAlert } = useModal();
    const { refreshData } = useDataRefresh();
    const translator = useTranslator();
    const { isComponentValid, onValidate } = useValidation('TFPARenewalRequalSummary');

    const [isLoading, setIsLoading] = useState(true);
    const [questionSetVM, setQuestionSetVM] = useState([])
    const [showErrors, setShowErrors] = useState(false)

    useEffect(() => {
        onAddrequalTFPA();
    }, [])


    const onAddrequalTFPA = () => {
        const submitting = false;

        const result = PolicyChangeService.updatePolicyPeriodReQualificationQuestions_TFPA(policyNumber, [], submitting, authHeader )
        .then(
            (res) => {
                const vm = res.map(abc => viewModelService.create(
                    abc,
                    'pc',
                    'edge.capabilities.quote.helper.questionset.dto.QuestionSetAnswersDTO'
                ))
                setQuestionSetVM(vm)
                setIsLoading(false);
            } 
        ) 
    }

    const handleValueChange = useCallback ((value, path)  => {
        _.set(questionSetVM, `${path}.value`, value)
        setQuestionSetVM(questionSetVM)
        refreshData();
    }, [refreshData, questionSetVM])

    const errMsgParser = (err) => {
        const errExpr = /error:/;
        const errMsgExpr = /^entity.\w*\/(.*)/;
        if (err && _.has(err, 'baseError')) {
          const messages = [];
          const retMsg = err.baseError;
          const errMsgs = retMsg.split(errExpr);
          errMsgs.forEach((msg) => {
            if (errMsgExpr.test(msg)) {
              const xx = errMsgExpr.exec(msg);
              messages.push(_.last(xx));
            }
          });
          return _.uniq(messages).join('\n\n\n');
        }
      };

    const onRequalSubmit = useCallback(() => {
        
        const submitting = true;
        const redirectPolicySummaryPath = `/policies/${policyNumber}/summary`;
        const data = _.get(questionSetVM[0], 'value');
        const questionArr = []
        questionArr.push(data)
        if(!isComponentValid) {
            setShowErrors(!isComponentValid)
            return
        }

        const result = PolicyChangeService.updatePolicyPeriodReQualificationQuestions_TFPA(policyNumber, questionArr, submitting, authHeader )
        .then(
            () => {
            showAlert({
                    title: messages.requalSubmittedTitle,
                    message: messages.requalSubtitle,
                    status: 'info',
                    icon: 'mi-error-outline',
                    confirmButtonText: messages.doneButton
                }).then( () => {
                    window.location.href = redirectPolicySummaryPath;
                })
            } 
        ).catch(error => {
            showAlert({
                title: messages.requalificationQuestionErrorMsg,
                message: errMsgParser(error),
                className: styles.jut__ModalNext__mod,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: messages.doneButton
            }).then( () => {
                window.location.href = redirectPolicySummaryPath;
            })
        })  
    }, [questionSetVM,isComponentValid, authHeader])

    const handleCancelClick = useCallback(() => {
    
        const redirectClaimsPath = `/policies/${policyNumber}/summary`;
        window.location.href = redirectClaimsPath;
    }, []);

    const formatTitleTypekey = useCallback( (msg) => {
        
        return translator({id: `questionkey.QuestionSet_${msg}.Name`})
    },[]);

    // DE17489
    const getPolicyTypeValue = () => {
        return <p>Policy Type&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <b>{`${policyType}`}</b>
        </p>
    };
    
    const overrides = {
        generalQuestionSet: {
            path: '[0]',
            title: formatTitleTypekey(_.get(questionSetVM, `[0].code`)),
            onValueChange: handleValueChange,
            onValidate,
            showErrors
        },
        policyType: {
            value: getPolicyTypeValue()
        },
    }

    const resolvers= {
        resolveComponentMap: {
            questionSet: QuestionSetComponent
        },
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onRequalSubmit: onRequalSubmit,
            handleCancelClick : handleCancelClick
        }
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={questionSetVM}
            overrideProps={overrides}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
            componentMap={resolvers.resolveComponentMap}
            onValidationChange={onValidate}
            onModelChange={setQuestionSetVM}
            showErrors= {showErrors}
        />
    );
};

export default TFPARenewalRequalSummary;